import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../../../constants';

const questionsModel = [
  {
    field: 'zalud_stiTreatment_recentPositiveTest',
    label:
      'Have you received a positive STI test for Chlamydia, Gonorrhea or Trichomoniasis in the past 30 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Please upload your positive test results for your provider to review. The document must be a photo (PNG, JPG) or PDF and must clearly show your name, the date of the test, and the diagnosis.',
    field: 'zalud_stiTreatment_upload',
    type: 'file_upload',
    accepts: ['application/pdf', ...IMAGE_TYPES],
    answer: [
      {
        resourceId: 'zalud_stiTreatment_upload',
        buttonLabel: 'Upload results'
      }
    ]
  },
  {
    field: 'zalud_stiTreatment_stisDiagnosed',
    label:
      'Which STI did you test positive for? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Chlamydia', key: 'chlamydia' },
        { value: 'Gonorrhea', key: 'gonorrhea' },
        { value: 'Trichomoniasis', key: 'trichomoniasis' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_gonorrheaTestSite',
    label:
      'What body site was your gonorrhea test collected from? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Genital/urethral', key: 'genital_urethral' },
        { value: 'Rectal', key: 'rectal' },
        { value: 'Throat/pharyngeal', key: 'throat_pharyngeal' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_sexAssignedAtBirth',
    label: 'What sex were you assigned at birth?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Female', key: 'female' },
        { value: 'Male', key: 'male' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_symptomsFemale',
    label: 'Are you currently experiencing any of the following symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Unusual eye discharge', key: 'eye_discharge' },
        {
          value: 'New or unusual rash or joint pain',
          key: 'rash_joint_pain'
        },
        {
          value: 'New headache or neck stiffness',
          key: 'headache_neck_stiffness'
        },
        {
          value: 'Sudden changes in your vision or hearing',
          key: 'vision_hearing_changes'
        },
        {
          value:
            "Inability to urinate or feeling like your bladder won't empty",
          key: 'urinary_inability'
        },
        {
          value:
            'Rectal symptoms (such as pain, bleeding, or the constant urge to pass stool)',
          key: 'rectal_symptoms'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_symptomsMale',
    label: 'Are you currently experiencing any of the following symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Unusual eye discharge', key: 'eye_discharge' },
        {
          value: 'New or unusual rash or joint pain',
          key: 'rash_joint_pain'
        },
        {
          value: 'Testicular pain or swelling',
          key: 'testicular_pain_swelling'
        },
        {
          value: 'New headache or neck stiffness',
          key: 'headache_neck_stiffness'
        },
        {
          value: 'Sudden changes in your vision or hearing',
          key: 'vision_hearing_changes'
        },
        {
          value:
            "Inability to urinate or feeling like your bladder won't empty",
          key: 'urinary_inability'
        },
        {
          value:
            'Rectal symptoms (such as pain, bleeding, or the constant urge to pass stool)',
          key: 'rectal_symptoms'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_sexualAssaultCare',
    label: 'Are you seeking care related to a recent sexual assault?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_currentSymptoms',
    label: 'Are you currently experiencing any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Fever (100.4 degrees or above)', key: 'fever' },
        { value: 'Pelvic pain', key: 'pelvic_pain' },
        { value: 'Nausea and/or vomiting', key: 'nausea_vomiting' },
        {
          value: 'Foul-smelling vaginal discharge',
          key: 'foul_vaginal_discharge'
        },
        { value: 'Abdominal pain', key: 'abdominal_pain' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_cephalosporinAllergy',
    label:
      'Do you have a known allergy to cephalosporin antibiotics (such as cephalexin, cefdinir, or ceftriaxone)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'I am not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_allergyReaction',
    label: 'Please describe what happened when you took the antibiotic.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'Hives, swelling of the face/lips/tongue, wheezing, or trouble breathing',
          key: 'hives_swelling_wheezing'
        },
        {
          value:
            'Severe blistering or peeling skin rash, or hospitalization because of the reaction',
          key: 'severe_blistering_hospitalization'
        },
        { value: 'A mild rash only', key: 'mild_rash_only' },
        {
          value: 'Nausea, vomiting, or diarrhea only',
          key: 'nausea_vomiting_diarrhea_only'
        },
        {
          value: "I don't remember the reaction",
          key: 'dont_remember_reaction'
        },
        {
          value:
            'I was told about the allergy but have never taken the medication',
          key: 'never_taken_medication'
        }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_recentTreatment',
    label:
      'Have you already been treated with medication for this positive test result, or received any other STI treatment in the past 30 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_symptomResolution',
    label: 'Did your symptoms resolve after that treatment?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, but I tested positive again (possible reinfection)',
          key: 'resolved_but_reinfected'
        },
        { value: 'Yes, and I have no symptoms now', key: 'resolved_no_symptoms' },
        { value: 'No, symptoms persisted', key: 'symptoms_persisted' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_partnerNotification',
    label: 'Have your sexual partners been notified of your positive test result?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, and they have been treated or are seeking treatment',
          key: 'yes_treated_or_seeking'
        },
        {
          value: 'Yes, but they have not been treated yet',
          key: 'yes_not_yet_treated'
        },
        {
          value: 'No, I have not been able to notify them',
          key: 'no_unable_to_notify'
        },
        { value: 'I prefer not to say', key: 'prefer_not_to_say' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_alcoholUse',
    label:
      'Do you currently drink alcohol or plan to drink alcohol in the next 7 days (this helps our doctors prescribe the best treatment to fit your lifestyle)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_stiTreatment_additionalComments'
    }
  },
  {
    field: 'zalud_stiTreatment_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_stiTreatment_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_stiTreatment_negativeTestIneligible',
    label: 'Positive result required',
    subLabel:
      'Our provider cannot provide treatment without a positive test result for Chlamydia, Gonorrhea or Trichomoniasis.',
    educationalSlide: `Our provider cannot provide treatment without a positive test result for Chlamydia, Gonorrhea or Trichomoniasis. Please visit a local, in-person clinic or view our at-home STI test <a href="https://www.zalud.com/product/std-sti-test" id="LabTestLink" target="_blank" rel="noopener">here</a>.`,
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'zalud_stiTreatment_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludStiTreatmentQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
